<template>
  <div>
    <!--右侧内容-->
    <div class="class_add_top"><a href="javascript:;" class="back" onclick="history.go(-1)">返回</a>问卷调查明细报表 </div>
    <div class="question_tongji">
      <div class="tongji_tit">
        <dl>
          <dt>{{params.title}}</dt>
          <dd>参与总人数 <span>{{params.isUsed}}</span>人</dd>
        </dl>
      </div>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr v-for="(item,index) in list" :key="item.id" :class="index%2==0 ? 'trbg' : ''">
          <td width="5%" class="font14">Q{{index+1}}</td>
          <td width="35%">{{item.title}}</td>
          <a v-if="item.questionType!='short' && item.questionType!='write'">
            <td v-for="i in item.answerInfoList" :key="i.id"><span>{{String.fromCharCode(65 + parseInt(i.no))}}</span><b>{{i.count}}</b>人</td>
          </a>
          <a v-if="item.questionType=='short' || item.questionType=='write'">
            <td width="60%">该题目类型无法进行统计</td>
          </a>
        </tr>
      </table>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [],
      params: {}
    }
  },
  created () {
    this.getQuestionnaire(this.$route.params.id)
    this.getListByExamCalc(this.$route.params.id)
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {},
  methods: {
    getListByExamCalc (id) {
      this.$api.post(this.$global.examApiPath, '/examQuestion/getListByExamCalc', {paperId: id}, r => {
        if (r.data) {
          this.list = r.data
        }
      })
    },
    getQuestionnaire (id) {
      this.$api.post(this.$global.examApiPath, '/examPaper/get', {id: id}, r => {
        this.params = r.data[0]
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/questionnaire/statistics.vue